import { render, staticRenderFns } from "./shopping-cart.vue?vue&type=template&id=61ae5699&"
import script from "./shopping-cart.vue?vue&type=script&lang=js&"
export * from "./shopping-cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports